var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "hb-section",
    {
      attrs: {
        title: _vm.$t("influencer_panel.funnel"),
        subtitle: _vm.$t("influencer_panel.funnel_hint"),
      },
    },
    [
      _c(
        "div",
        { staticClass: "funnel" },
        _vm._l(_vm.steps, function (step, index) {
          return _c("div", { key: step.key, staticClass: "funnel__step" }, [
            _c("div", { staticClass: "funnel__row" }, [
              _c("span", { staticClass: "funnel__label" }, [
                _vm._v(_vm._s(_vm.$t("influencer_panel.funnel_" + step.key))),
              ]),
              _c("span", { staticClass: "funnel__value" }, [
                _vm._v(_vm._s(step.count.toLocaleString("pt-BR"))),
              ]),
            ]),
            _c("div", { staticClass: "funnel__bar" }, [
              _c("div", {
                staticClass: "funnel__bar-fill",
                style: { width: _vm.widthOf(step) + "%" },
              }),
            ]),
            index > 0
              ? _c(
                  "div",
                  {
                    staticClass: "funnel__delta",
                    class: {
                      "funnel__delta--worst": step.key === _vm.worstStepKey,
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("influencer_panel.funnel_from_previous", {
                            pct: _vm.retentionOf(index),
                          })
                        ) +
                        " "
                    ),
                    step.key === _vm.worstStepKey
                      ? [
                          _vm._v(
                            "— " +
                              _vm._s(
                                _vm.$t("influencer_panel.funnel_biggest_drop")
                              )
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ])
        }),
        0
      ),
      _c(
        "p",
        { staticClass: "funnel__note" },
        [
          _c("feather-icon", { attrs: { icon: "InfoIcon", size: "13" } }),
          _vm._v(
            " " + _vm._s(_vm.$t("influencer_panel.funnel_consent_note")) + " "
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }